import { module as BaseModule } from 'modujs';

export default class extends BaseModule {
  constructor(m) {
    super(m);
  }

  init() {
    const img = this.el;

    // Asegúrate de que sea una imagen SVG
    const src = img.getAttribute('src');
    if (!src || !src.endsWith('.svg')) return;

    // Carga y reemplaza el SVG
    fetch(src)
      .then((res) => res.text())
      .then((svgText) => {
        const parser = new DOMParser();
        const svgDoc = parser.parseFromString(svgText, 'image/svg+xml');
        const svgEl = svgDoc.querySelector('svg');

        if (svgEl) {
          // Copiar atributos del <img> al <svg>
          for (let i = 0; i < img.attributes.length; i++) {
            const attr = img.attributes[i];
            if (!svgEl.hasAttribute(attr.name)) {
              svgEl.setAttribute(attr.name, attr.value);
            }
          }

          svgEl.removeAttribute('width');
          svgEl.removeAttribute('height');
          /* svgEl.setAttribute('preserveAspectRatio', 'xMidYMid meet'); */

          img.replaceWith(svgEl);
        }
      })
      .catch((err) => console.error('Error al cargar SVG:', err));
  }
}

